import { Id } from "lib-shared/shared/models/types";
import { MyIsNotEmpty } from "../../shared/modules/form-validation/decorators/my-is-not-empty";


export class CertificateRequestForm {
    @MyIsNotEmpty()
    vendor_declined_reason = '';
}